import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import download from 'downloadjs';
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel)

export default {
	name: 'order',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		Loader,
		JsonExcel,
		download
	},
	data() {
		return {
			// currentPage: 0,
			listReportDataforxls3: [],
			csvFieldsForXls3: {},
			csvFieldsForXls2: {},
			listReportDataforxls2: [],
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname1: '',
			reportname2: '',
			reportname3: '',
			reportname4: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			listpendingForBatchData: {
				totalquantity: 0,
				result: [],
			},
			ponoFlt: "",
			fromDateFlt: "",
			toDateFlt: "",

			isLoading: false,
			listClientData: [],
			listWarehouseData: [],
			totalrowsData: [],
			listpendingForBatchDataCsv: [],

			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,

			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',

			//checkStatus: 0,
			searchchannel: '',
			fromDateBatchPending: "",
			toDateBatchPending: "",
			channellist: [],
			showOrderAllocationRacks: false,
			allocationResultData: [],
			formattedDate: '',
			ordertype: '',
			ordersubtype: '',
			user_type: '',
			userid: '',
			useremail: '',
			// totalRows:0,


			orderid: '',
			zoneBatchPending: '',
			selectAllBatchPending: false,
			orderItemids: [],
			zonelistData: [],
			batchCreationShow: false,


			fromDateAllocatePending: '',
			toDateAllocatePending: '',
			listpendingForAllocationData: {
				totalquantity: 0,
				result: [],
			},
			selectAllAllocationPending: false,
			pendingbatchids: [],
			pickerid: '',
			pickerListData: '',
			pickerAssignmentShow: false,
			SelectPickerErr: '',

			allocatedbatchids: [],
			listAllocatedInpickingData: {
				totalquantity: 0,
				result: [],
			},
			fromDateAllocated: '',
			toDateAllocated: '',
			pickeridAllocated: '',
			selectAllAllocated: false,
			pickeridassigned: '',
			pickerReAssignmentShow: false,
			reAssignpickerid: '',
			SelectRePickerErr: '',

			listBatchPendingDataCsv: [],
			listUnallocatedBatchDataCsv: [],
			listallocatedDataCsv: [],
			listCompletedDataCsv: [],
			listFilterZoneArray: [],

			pickeridCompleted: '',
			fromDateCompleted: '',
			toDateCompleted: '',
			listCompletedData: {
				totalquantity: 0,
				result: [],
			},
			recordLimit: 0,
			limitExeed: false

		}
	},
	model: {
		totalqty: 0
	},
	computed: {},
	filters: {
		moment: function(date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY');
		},
		momentDateTime: function(date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.userid = userdetail.userid;
		this.useremail = userdetail.email;
		this.user_type = userdetail.utype;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname1 = this.$t('editedjson.zoneBatchpendingReport')
		this.reportname1 = this.reportname1 + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.reportname2 = this.$t('editedjson.zonePendingAllocationgReport')
		this.reportname2 = this.reportname2 + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.reportname3 = this.$t('editedjson.zoneAllocatedOrInpickingReport')
		this.reportname3 = this.reportname3 + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.reportname4 = this.$t('editedjson.zoneCompletedbatchReport')
		this.reportname4 = this.reportname4 + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client;
		if(localStorage.getItem('selectedClient')!=='undefined' && localStorage.getItem('selectedWarehouse')!=='undefined'){
			this.getSalesChannels();
			this.getZoneList();
		 	this.getPickersList();
		}
		//console.log(this.user_type);
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getPickersList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
		this.getRecordLimit()
		this.$root.$on('localStorageChanged', (newValue) => {
            // Update your local data
            this.warehouse = newValue;
            //
            //onsole.log(newValue+"===============in event")
            // Perform any other actions needed
            this.getZoneList();
			this.getPickersList();
			this.getSalesChannels();
	});
 }, // End computed
	methods: {
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getOrderListForBatchCreationForXls(3)
			}
		},
		Choosetype2() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getPendinAllocationBatchForXls(3)
			}
		},
		Choosetype3() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getAllocatedPendingBatchesForXls(3)
			}
		},
		Choosetype4() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getCompletedBatchesForXls(3)
			}
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		//open new form(popup)
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter = {}) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'
			//Fields
			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function(item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},

		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageNo = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageNo = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		if (this.clientid)
		// 			this.getSalesChannels();
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = [];
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = '';
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.getPickersList();
		// 				this.getZoneList();
		// 			}
		// 		}
		// 	}
		// 	this.listOrderReportData = {
		// 		ordercount: 0,
		// 		totalsku: 0,
		// 		totalquantity: 0,
		// 		result: [],
		// 	};
		// 	this.pageNo = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageNo = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getSalesChannels();
		// 			this.getZoneList();
		// 			this.getPickersList();
		// 			// console.log(this.warehouse);
		// 			// this.getOrderListReport();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		getPickersList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehousePickerList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.pickerListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},

		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (window.localStorage.getItem('selectedClient')==='') {
				this.ClientErr = this.$t('common.clientError');
				return false;
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'orderSalesChannelList',
					'data': {
						clientid: this.clientid
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},

		getZoneList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getZonesByWarehouse',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					if (result.data.data.ErrorCode == 0) {
						this.zonelistData = result.data.data.data;
						//console.log(this.zonelistData);
						for (var i = 0; i < this.zonelistData.length; i++) {
							var temp = [];
							temp = {
								zoneid: this.zonelistData[i].zoneid,
								zonename: this.zonelistData[i].zonename,
							}
							this.listFilterZoneArray.push(temp);
						}
						//console.log(this.listFilterZoneArray);
					} else {
						this.zonelistData = [];
						this.listFilterZoneArray = [];
					}

				}, error => {
					console.error(error)
				})

		},
		getZoneName(zoneid) {
			var zonename = '';
			for (var i = 0; i < this.listFilterZoneArray.length; i++) {
				if (this.listFilterZoneArray[i].zoneid == zoneid) {
					zonename = this.listFilterZoneArray[i].zonename;
					break;
				}
			}
			return zonename;
		},

		getOrderListForBatchCreationSearch() {
			this.totalPage = 0;
			this.totalRows = 0;
			this.currentPage = 1;
			this.selectAllBatchPending = false;
			this.orderItemids = [];
			this.getOrderListForBatchCreation();
		},

		getOrderListForBatchCreation() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.limitExeed = false
			this.show = false;
			this.download = true;
			if (this.fromDateBatchPending == "" || this.fromDateBatchPending == null) {
				this.fromDateBatchPending = "";
			} else {
				this.fromDateBatchPending = this.dateFormat(this.fromDateBatchPending) + " 00:00:00";
			}
			if (this.toDateBatchPending == "" || this.toDateBatchPending == null) {
				this.toDateBatchPending = "";
			} else {
				this.toDateBatchPending = this.dateFormat(this.toDateBatchPending) + " 23:59:59";
			}

			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				if (this.user_type == 'system_user') {
					this.$alertify.error(this.$t('common.clientError'))
					this.ClientErr = '';
				} else {
					this.$alertify.error(this.$t('common.clientError'))
				}
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}


			this.isLoading = true;

			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				orderid: this.orderid.trim(),
				zoneid: this.zoneBatchPending,
				fromdate: this.dateFormat1(this.fromDateBatchPending),
				todate: this.dateFormat2(this.toDateBatchPending),
				saleschannel: this.searchchannel,
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getPendingPicktasks',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					if (result.data.errorCode == -1) {
						this.listpendingForBatchData.result = [];
						this.listpendingForBatchData.totalquantity = 0;
					} else {
						this.listpendingForBatchData.result = result.data.data;
						this.listpendingForBatchData.totalquantity = result.data.totalRows;
						if (Number(this.listpendingForBatchData.totalquantity) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},

		getOrderListForBatchCreationCSV() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};

			this.show = true;
			this.download = false;

			if (this.fromDateBatchPending == "" || this.fromDateBatchPending == null) {
				this.fromDateBatchPending = "";
			} else {
				this.fromDateBatchPending = this.dateFormat(this.fromDateBatchPending) + " 00:00:00";
			}
			if (this.toDateBatchPending == "" || this.toDateBatchPending == null) {
				this.toDateBatchPending = "";
			} else {
				this.toDateBatchPending = this.dateFormat(this.toDateBatchPending) + " 23:59:59";
			}

			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.ClientErr = '';
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}


			this.isLoading = true;

			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				orderid: this.orderid.trim(),
				zoneid: this.zoneBatchPending,
				fromdate: this.dateFormat1(this.fromDateBatchPending),
				todate: this.dateFormat2(this.toDateBatchPending),
				saleschannel: this.searchchannel,
				userid: this.userid,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getPendingPicktasksCsv',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.data.length > 0) {
						this.show = true;
						this.download = false;
						this.csvFields = {
							'createddate': this.$t('common.createdDate'),
							'eancode':this.$t('common.eanCode'),
							'orderid': this.$t('common.orderID'),
							'productid': this.$t('common.productId'),
							'qty': this.$t('common.quantity'),
							'rackid': this.$t('warehouseRacks.rackId'),
							'saleschannel': this.$t('common.salesChannel'),
							'zoneid': this.$t('editedjson.zoneId'),
							'id':  this.$t('editedjson.orderItemRackId')
						};
						var dateFilder = ['createddate'];
						var skipFilter = [];
						this.listBatchPendingDataCsv = result.data.data;
						this.jsonToCSV(this.$t('editedjson.batchPendingCsv'), this.listBatchPendingDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
					} else {
						if (result.data.status == true) {
							this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}

				}, error => {
					console.error(error)
				})
		},
		getOrderListForBatchCreationForXls() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			if (this.fromDateBatchPending == "" || this.fromDateBatchPending == null) {
				this.fromDateBatchPending = "";
			} else {
				this.fromDateBatchPending = this.dateFormat(this.fromDateBatchPending) + " 00:00:00";
			}
			if (this.toDateBatchPending == "" || this.toDateBatchPending == null) {
				this.toDateBatchPending = "";
			} else {
				this.toDateBatchPending = this.dateFormat(this.toDateBatchPending) + " 23:59:59";
			}



			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				orderid: this.orderid.trim(),
				zoneid: this.zoneBatchPending,
				fromdate: this.dateFormat1(this.fromDateBatchPending),
				todate: this.dateFormat2(this.toDateBatchPending),
				saleschannel: this.searchchannel,
				userid: this.userid,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getPendingPicktasksCsv',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					if (result.data.data.length > 0) {
						this.listReportDataforxls = [];

							this.csvFieldsForXls[this.$t('common.orderID')]='orderid',
							this.csvFieldsForXls[this.$t('common.productId')]='productid',
							this.csvFieldsForXls[this.$t('common.eanCode')]='eancode',
							this.csvFieldsForXls[this.$t('common.rackID')]='rackid',
							this.csvFieldsForXls[this.$t('common.quantity')]='qty',
							this.csvFieldsForXls[this.$t('common.salesChannel')]='saleschannel',
							this.csvFieldsForXls[this.$t('editedjson.zoneId')]='zoneid',
							this.csvFieldsForXls[this.$t('editedjson.orderItemRackId')]='id',
							this.csvFieldsForXls[this.$t('common.createdDate')]='createddate',

						this.listReportDataforxls = result.data.data;
					} else {
						if (result.data.status == true) {
							this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}
				}, error => {
					console.error(error)
				})
		},
		selectAllCheckboxBathPending: function() {
			//this.rackIds = [];
			if (this.selectAllBatchPending) {
				for (let order in this.listpendingForBatchData.result) {
					if (this.orderItemids.indexOf(this.listpendingForBatchData.result[order].id) == -1)
						this.orderItemids.push(this.listpendingForBatchData.result[order].id);
				}
			} else {
				for (let order in this.listpendingForBatchData.result) {
					if (this.orderItemids.indexOf(this.listpendingForBatchData.result[order].id) >= 0)
						this.orderItemids.splice(this.orderItemids.indexOf(this.listpendingForBatchData.result[order].id), 1);
				}
			}
		},

		assignOrderToBatch() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.orderItemids.length == 0) {
				this.$alertify.error("Please select atleast Pick Task");
				return false;
			}

			this.isLoading = true;
			this.input = {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				selectedorder: this.orderItemids,
				userid: this.userid,
				zoneid: this.zoneBatchPending,
			}
			//console.log(this.input);
			//return false;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'createBatchForPendingTask',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.errorCode == 0) {
						this.$alertify.success(result.data.msg);
						this.getOrderListForBatchCreation();

					} else {
						this.$alertify.error(result.data.msg);
					}
					this.isLoading = false;
					this.selectAllBatchPending = false;
					//this.pickerid = '';
					this.orderItemids = [];

				}, error => {
					console.error(error);
				});


		},

		resetAllBatchPending: function(myAction) {
			if (myAction == 1) {
				this.orderItemids = [];
				this.selectAllBatchPending = false;
			} else {}
		},


		/* Starting For Pending Batches  */

		getPendinAllocationBatchSearch() {
			this.totalPage = 0;
			this.totalRows = 0;
			this.currentPage = 1;
			this.selectAllAllocationPending = false;
			this.pendingbatchids = [];
			this.getPendinAllocationBatch();
		},

		getPendinAllocationBatch() {
			this.limitExeed = false
			this.show = false
			this.download = true
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.fromDateAllocatePending == "" || this.fromDateAllocatePending == null) {
				this.fromDateAllocatePending = "";
			} else {
				this.fromDateAllocatePending = this.dateFormat(this.fromDateAllocatePending) + " 00:00:00";
			}
			if (this.toDateAllocatePending == "" || this.toDateAllocatePending == null) {
				this.toDateAllocatePending = "";
			} else {
				this.toDateAllocatePending = this.dateFormat(this.toDateAllocatePending) + " 23:59:59";
			}

			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				if (this.user_type == 'system_user') {
					this.$alertify.error(this.$t('common.clientError'))
					this.ClientErr = '';
				} else {
					this.$alertify.error(this.$t('common.clientError'))
				}
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			this.isLoading = true;
			var temp = this.currentPage - 1;
			this.input = ({
				offset: temp * this.pageLimit,
				limit: this.pageLimit,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				zoneid: this.zoneBatchPending,
				fromdate: this.dateFormat1(this.fromDateAllocatePending),
				todate: this.dateFormat2(this.toDateAllocatePending),
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getBatchesPendingForAllocation',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					if (result.data.errorCode == -1) {
						this.listpendingForAllocationData.result = [];
						this.listpendingForAllocationData.totalquantity = 0;
					} else {
						this.listpendingForAllocationData.result = result.data.data;
						this.listpendingForAllocationData.totalquantity = result.data.totalRows;
						this.resultCount = result.data.totalRows;
						this.totalRows = result.data.totalRows;
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (result.data.totalRows == 0) {
							this.totalPage = 0
							this.currentPage = 1
						} else if (this.totalRows <= this.pageLimit) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})

		},

		getPendinAllocationBatchCSV() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			if (this.fromDateAllocatePending == "" || this.fromDateAllocatePending == null) {
				this.fromDateAllocatePending = "";
			} else {
				this.fromDateAllocatePending = this.dateFormat(this.fromDateAllocatePending) + " 00:00:00";
			}
			if (this.toDateAllocatePending == "" || this.toDateAllocatePending == null) {
				this.toDateAllocatePending = "";
			} else {
				this.toDateAllocatePending = this.dateFormat(this.toDateAllocatePending) + " 23:59:59";
			}

			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			this.isLoading = true;
			var temp = this.currentPage - 1;
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				zoneid: this.zoneBatchPending,
				fromdate: this.dateFormat1(this.fromDateAllocatePending),
				todate: this.dateFormat2(this.toDateAllocatePending),
				userid: this.userid,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getBatchesPendingForAllocationCSV',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.data.length > 0) {
						this.show = true;
						this.download = false;
						this.csvFields = {
							'assignedby':  this.$t('editedjson.assignedBy'),
							'assigneddate': this.$t('orders.assignedDate'),
							'batchcount': this.$t('editedjson.batchcount'),
							'batchid': this.$t('common.batchID'),
							'clientid': this.$t('client.clientId'),
							'createddatetime': this.$t('common.createdDate'),
							'pickedcount': this.$t('editedjson.pickedCount'),
							'status': this.$t('common.status'),
							'warehouseid': this.$t('common.warehouseID'),
							'zoneid': this.$t('editedjson.zoneId'),
						};
						var dateFilder = ['createddatetime'];
						var skipFilter = [];
						this.listUnallocatedBatchDataCsv = result.data.data;
						this.jsonToCSV(this.$t('editedjson.allocationPendingCsv'), this.listUnallocatedBatchDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
					} else {
						if (result.data.status == true) {
							this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}

				}, error => {
					console.error(error)
				})

		},

		getPendinAllocationBatchForXls() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			if (this.fromDateAllocatePending == "" || this.fromDateAllocatePending == null) {
				this.fromDateAllocatePending = "";
			} else {
				this.fromDateAllocatePending = this.dateFormat(this.fromDateAllocatePending) + " 00:00:00";
			}
			if (this.toDateAllocatePending == "" || this.toDateAllocatePending == null) {
				this.toDateAllocatePending = "";
			} else {
				this.toDateAllocatePending = this.dateFormat(this.toDateAllocatePending) + " 23:59:59";
			}

			var temp = this.currentPage - 1;
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				zoneid: this.zoneBatchPending,
				fromdate: this.dateFormat1(this.fromDateAllocatePending),
				todate: this.dateFormat2(this.toDateAllocatePending),
				userid: this.userid,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getBatchesPendingForAllocationCSV',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.data.length > 0) {
						this.listReportDataforxls2 = [];
						this.csvFieldsForXls2[this.$t('editedjson.zoneId')]='zoneid',
						this.csvFieldsForXls2[this.$t('common.batchID')]='batchid',
						this.csvFieldsForXls2[this.$t('editedjson.assignedBy')]='assignedby',
						this.csvFieldsForXls2[this.$t('orders.assignedDate')]='assigneddate',
						this.csvFieldsForXls2[this.$t('editedjson.batchcount')]='batchcount',
						this.csvFieldsForXls2[this.$t('client.clientId')]='clientid',
						this.csvFieldsForXls2[this.$t('common.createdDate')]='createddatetime',
						this.csvFieldsForXls2[this.$t('editedjson.pickedCount')]='pickedcount',
						this.csvFieldsForXls2[this.$t('common.status')]='status',
						this.csvFieldsForXls2[this.$t('common.warehouseID')]='warehouseid'

						this.listReportDataforxls2 = result.data.data;
					} else {
						if (result.data.status == true) {
							this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}


				}, error => {
					console.error(error)
				})

		},
		assignBatchToPicker() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.pendingbatchids.length == 0) {
				this.$alertify.error("Please select atleast One Batch");
				return false;
			}

			if (this.pickerid == "") {
				this.SelectPickerErr = "Please Select Picker";
				return false;
			}

			this.isLoading = true;
			this.input = {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				selectedbatch: this.pendingbatchids,
				useremail: this.useremail,
				pickeruserid: parseInt(this.pickerid),
			}
			//console.log(this.input); return false;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'assignBatchToPicker',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.errorCode == 0) {
						this.$alertify.success(result.data.msg);
						this.getPendinAllocationBatchSearch();

					} else {
						this.$alertify.error(result.data.msg);
					}
					this.isLoading = false;
					this.pickerAssignmentShow = false;
					this.selectAllAllocationPending = false;
					this.pickerid = '';
					this.pendingbatchids = [];

				}, error => {
					console.error(error);
				});


		},


		selectAllCheckboxAllocationPending: function() {
			//this.rackIds = [];
			if (this.selectAllAllocationPending) {
				for (let order in this.listpendingForAllocationData.result) {
					if (this.pendingbatchids.indexOf(this.listpendingForAllocationData.result[order].batchid) == -1)
						this.pendingbatchids.push(this.listpendingForAllocationData.result[order].batchid);
				}
			} else {
				for (let order in this.listpendingForAllocationData.result) {
					if (this.pendingbatchids.indexOf(this.listpendingForAllocationData.result[order].batchid) >= 0)
						this.pendingbatchids.splice(this.pendingbatchids.indexOf(this.listpendingForAllocationData.result[order].batchid), 1);
				}
			}
		},

		resetAllAllocationPending: function(myAction) {
			if (myAction == 1) {
				this.pendingbatchids = [];
				this.selectAllBatchPending = false;
			} else {}
		},

		resetAllocatePending() {
			this.show = false;
			this.download = true;
			this.fromDateAllocatePending = '';
			this.toDateAllocatePending = '';
			this.listpendingForAllocationData = {
				totalquantity: 0,
				result: [],
			};
			this.selectAllAllocationPending = false;
			this.pendingbatchids = [];
			this.totalPage = 0;
			this.totalRows = 0;
			this.zoneBatchPending = '';
		},



		/*   Start Function For Third tab  */

		getAllocatedPendingBatchesSearch() {
			this.totalPage = 0;
			this.totalRows = 0;
			this.currentPage = 1;
			this.allocatedbatchids = [];
			this.selectAllAllocated = false;
			this.getAllocatedPendingBatches();
		},
		getAllocatedPendingBatches() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.fromDateAllocated == "" || this.fromDateAllocated == null) {
				this.fromDateAllocated = "";
			} else {
				this.fromDateAllocated = this.dateFormat(this.fromDateAllocated) + " 00:00:00";
			}
			this.limitExeed = false
			this.show = false
			this.download = true
			if (this.toDateAllocated == null || this.toDateAllocated == "") {
				this.toDateAllocated = "";
			} else {
				this.toDateAllocated = this.dateFormat(this.toDateAllocated) + " 23:59:59";
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				if (this.user_type == 'system_user') {
					this.ClientErr = '';
				} else {
					this.ClientErr = this.$t('common.clientError');
				}
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			this.isLoading = true;
			var temp = this.currentPage - 1;
			this.input = ({
				offset: temp * this.pageLimit,
				limit: this.pageLimit,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				zoneid: this.zoneBatchPending,
				fromdate: this.fromDateAllocated,
				todate: this.toDateAllocated,
				pickerid: this.pickeridAllocated,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getBathesAllocatedInpicking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					if (result.data.errorCode == -1) {
						this.listAllocatedInpickingData.result = [];
						this.listAllocatedInpickingData.totalquantity = 0;
					} else {
						this.listAllocatedInpickingData.result = result.data.data;
						this.listAllocatedInpickingData.totalquantity = result.data.totalRows;
						this.resultCount = result.data.totalRows;
						this.totalRows = result.data.totalRows;
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (result.data.totalRows == 0) {
							this.totalPage = 0
							this.currentPage = 1
						} else if (this.totalRows <= this.pageLimit) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})

		},

		getAllocatedPendingBatchesCSV() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			if (this.fromDateAllocated == "" || this.fromDateAllocated == null) {
				this.fromDateAllocated = "";
			} else {
				this.fromDateAllocated = this.dateFormat(this.fromDateAllocated) + " 00:00:00";
			}
			if (this.toDateAllocated == null || this.toDateAllocated == "") {
				this.toDateAllocated = "";
			} else {
				this.toDateAllocated = this.dateFormat(this.toDateAllocated) + " 23:59:59";
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			this.isLoading = true;

			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				zoneid: this.zoneBatchPending,
				fromdate: this.fromDateAllocated,
				todate: this.toDateAllocated,
				pickerid: this.pickeridAllocated,
				userid: this.userid,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getBathesAllocatedInpickingCSV',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.data.length > 0) {
						this.show = true;
						this.download = false;
						this.csvFields = {
							'assignedby': this.$t('editedjson.assignedBy'),
							'assigneddate': this.$t('orders.assignedDate'),
							'batchcount': this.$t('editedjson.batchcount'),
							'batchid': this.$t('common.batchID'),
							'clientid': this.$t('client.clientId'),
							'createddatetime': this.$t('common.createdDate'),
							'pickedcount': this.$t('editedjson.pickedCount'),
							'status': this.$t('common.status'),
							'warehouseid': this.$t('common.warehouseID'),
							'zoneid': this.$t('editedjson.zoneId'),
							'email': this.$t('editedjson.assignedUserId'),
							'fullname': this.$t('editedjson.assignedUserName'),
						};
						var dateFilder = ['createddatetime'];
						var skipFilter = [];
						this.listallocatedDataCsv = result.data.data;
						this.jsonToCSV(this.$t('editedjson.allocatedInpickingCsv'), this.listallocatedDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
					} else {
						if (result.data.status == true) {
							this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}

				}, error => {
					console.error(error)
				})

		},
		getAllocatedPendingBatchesForXls() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			if (this.fromDateAllocated == "" || this.fromDateAllocated == null) {
				this.fromDateAllocated = "";
			} else {
				this.fromDateAllocated = this.dateFormat(this.fromDateAllocated) + " 00:00:00";
			}
			if (this.toDateAllocated == null || this.toDateAllocated == "") {
				this.toDateAllocated = "";
			} else {
				this.toDateAllocated = this.dateFormat(this.toDateAllocated) + " 23:59:59";
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}



			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				zoneid: this.zoneBatchPending,
				fromdate: this.fromDateAllocated,
				todate: this.toDateAllocated,
				pickerid: this.pickeridAllocated,
				userid: this.userid,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getBathesAllocatedInpickingCSV',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.data.length > 0) {
						this.listReportDataforxls3 = [];

						this.csvFieldsForXls3[this.$t('editedjson.zoneId')]='zoneid',
						this.csvFieldsForXls3[this.$t('common.batchID')]='batchid',
						this.csvFieldsForXls3[this.$t('editedjson.batchcount')]='batchcount',
						this.csvFieldsForXls3[this.$t('common.createdDate')]='createddatetime',
						this.csvFieldsForXls3[this.$t('editedjson.pickedCount')]='pickedcount',
						this.csvFieldsForXls3[this.$t('common.status')]='status',
						this.csvFieldsForXls3[this.$t('editedjson.assignedBy')]='assignedby',
						this.csvFieldsForXls3[this.$t('orders.assignedDate')]='assigneddate',
						this.csvFieldsForXls3[this.$t('common.warehouseID')]='warehouseid',
						this.csvFieldsForXls3[this.$t('client.clientId')]='clientid',
						this.csvFieldsForXls3[this.$t('editedjson.assignedUserId')]='email',
						this.csvFieldsForXls3[this.$t('editedjson.assignedUserName')]='fullname',


						this.listReportDataforxls3 = result.data.data;
					} else {
						if (result.data.status == true) {
							this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}


				}, error => {
					console.error(error)
				})

		},

		selectAllCheckboxAllocated: function() {
			//this.rackIds = [];
			if (this.selectAllAllocated) {
				for (let order in this.listAllocatedInpickingData.result) {
					if (this.allocatedbatchids.indexOf(this.listAllocatedInpickingData.result[order].batchid) == -1)
						this.allocatedbatchids.push(this.listAllocatedInpickingData.result[order].batchid);
				}
			} else {
				for (let order in this.listAllocatedInpickingData.result) {
					if (this.allocatedbatchids.indexOf(this.listAllocatedInpickingData.result[order].batchid) >= 0)
						this.allocatedbatchids.splice(this.allocatedbatchids.indexOf(this.listAllocatedInpickingData.result[order].batchid), 1);
				}
			}
		},

		resetAllAllocated: function(myAction) {
			if (myAction == 1) {
				this.pendingbatchids = [];
				this.selectAllBatchPending = false;
			} else {}
		},

		reAssignBatchToPicker() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.allocatedbatchids.length == 0) {
				this.$alertify.error("Please select atleast One Batch");
				return false;
			}

			if (this.reAssignpickerid == "") {
				this.SelectRePickerErr = this.$t('consolidation.selectPickerErr');
				return false;
			}

			this.isLoading = true;
			this.input = {
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				selectedbatch: this.allocatedbatchids,
				useremail: this.useremail,
				pickeruserid: parseInt(this.reAssignpickerid),
			}
			//console.log(this.input); return false;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'reAssignBatchToPicker',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.errorCode == 0) {
						this.$alertify.success(result.data.msg);
						this.getAllocatedPendingBatchesSearch();

					} else {
						this.$alertify.error(result.data.msg);
					}
					this.isLoading = false;
					this.pickerReAssignmentShow = false;
					this.selectAllAllocated = false;
					this.reAssignpickerid = '';
					this.pendingbatchids = [];

				}, error => {
					console.error(error);
				});


		},


		/* ---------- Start Function For Forth tab ------------- */

		getCompletedBatchesSearch() {
			this.totalPage = 0;
			this.totalRows = 0;
			this.currentPage = 1;
			this.getCompletedBatches();
		},

		getCompletedBatches() {
			this.limitExeed = false
			this.show = false
			this.download = true
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.fromDateCompleted == "" || this.fromDateCompleted == null) {
				this.fromDateCompleted = "";
			} else {
				this.fromDateCompleted = this.dateFormat(this.fromDateCompleted) + " 00:00:00";
			}
			if (this.toDateCompleted == null || this.toDateCompleted == "") {
				this.toDateCompleted = "";
			} else {
				this.toDateCompleted = this.dateFormat(this.toDateCompleted) + " 23:59:59";
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				if (this.user_type == 'system_user') {
					this.$alertify.error(this.$t('common.clientError'))
					this.ClientErr = '';
				} else {
					this.$alertify.error(this.$t('common.clientError'))
				}
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			this.isLoading = true;
			var temp = this.currentPage - 1;
			this.input = ({
				offset: temp * this.pageLimit,
				limit: this.pageLimit,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient'),
				zoneid: this.zoneBatchPending,
				fromdate: this.fromDateCompleted,
				todate: this.toDateCompleted,
				pickerid: this.pickeridCompleted,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getCompletedBatches',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					if (result.data.errorCode == -1) {
						this.listCompletedData.result = [];
						this.listCompletedData.totalquantity = 0;
					} else {
						this.listCompletedData.result = result.data.data;
						this.listCompletedData.totalquantity = result.data.totalRows;
						this.resultCount = result.data.totalRows;
						this.totalRows = result.data.totalRows;
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (result.data.totalRows == 0) {
							this.totalPage = 0
							this.currentPage = 1
						} else if (this.totalRows <= this.pageLimit) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})

		},

		getCompletedBatchesCSV() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};

			if (this.fromDateCompleted == "" || this.fromDateCompleted == null) {
				this.fromDateCompleted = "";
			} else {
				this.fromDateCompleted = this.dateFormat(this.fromDateCompleted) + " 00:00:00";
			}
			if (this.toDateCompleted == null || this.toDateCompleted == "") {
				this.toDateCompleted = "";
			} else {
				this.toDateCompleted = this.dateFormat(this.toDateCompleted) + " 23:59:59";
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				if (this.user_type == 'system_user') {
					this.ClientErr = '';
				} else {
					this.$alertify.error(this.$t('common.clientError'))
				}
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			this.isLoading = true;

			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: this.clientid,
				zoneid: this.zoneBatchPending,
				fromdate: this.fromDateCompleted,
				todate: this.toDateCompleted,
				pickerid: this.pickeridCompleted,
				userid: this.userid,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getCompletedBatchesCSV',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.data.length > 0) {
						this.show = true;
						this.download = false;
							this.csvFields = {
							'assignedby': this.$t('editedjson.assignedBy'),
							'assigneddate': this.$t('orders.assignedDate'),
							'batchcount': this.$t('editedjson.batchcount'),
							'batchid': this.$t('common.batchID'),
							'clientid': this.$t('client.clientId'),
							'createddate': this.$t('common.createdDate'),
							'pickedcount': this.$t('editedjson.pickedCount'),
							'status': this.$t('common.status'),
							'warehouseid': this.$t('common.warehouseID'),
							'zoneid': this.$t('editedjson.zoneId'),
							'email': this.$t('editedjson.assignedUserId'),
							'fullname': this.$t('editedjson.assignedUserName'),
						};
						var dateFilder = ['createddatetime'];
						var skipFilter = [];
						this.listCompletedDataCsv = result.data.data;
						this.jsonToCSV(this.$t('editedjson.completedBatchCsv'), this.listCompletedDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
					} else {
						if (result.data.status == true) {
							this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}

				}, error => {
					console.error(error)
				})

		},
		getCompletedBatchesForXls() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			if (this.fromDateCompleted == "" || this.fromDateCompleted == null) {
				this.fromDateCompleted = "";
			} else {
				this.fromDateCompleted = this.dateFormat(this.fromDateCompleted) + " 00:00:00";
			}
			if (this.toDateCompleted == null || this.toDateCompleted == "") {
				this.toDateCompleted = "";
			} else {
				this.toDateCompleted = this.dateFormat(this.toDateCompleted) + " 23:59:59";
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				if (this.user_type == 'system_user') {
					this.ClientErr = '';
				} else {
					this.$alertify.error(this.$t('common.clientError'))
				}
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}



			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: this.clientid,
				zoneid: this.zoneBatchPending,
				fromdate: this.fromDateCompleted,
				todate: this.toDateCompleted,
				pickerid: this.pickeridCompleted,
				userid: this.userid,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getCompletedBatchesCSV',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.data.length > 0) {
						this.listReportDataforxls = [];
						this.csvFieldsForXls[this.$t('editedjson.zoneId')]='zoneid',
						this.csvFieldsForXls[this.$t('common.batchID')]='batchid',
						this.csvFieldsForXls[this.$t('editedjson.batchcount')]='batchcount',
						this.csvFieldsForXls[this.$t('common.status')]='status',
						this.csvFieldsForXls[this.$t('editedjson.pickedCount')]='pickedcount',
						this.csvFieldsForXls[this.$t('common.createdDate')]='createddatetime',
						this.csvFieldsForXls[this.$t('editedjson.assignedBy')]='assignedby',
						this.csvFieldsForXls[this.$t('orders.assignedDate')]='assigneddate',
						this.csvFieldsForXls[this.$t('common.warehouseID')]='warehouseid',
						this.csvFieldsForXls[this.$t('client.clientId')]='clientid',
						this.csvFieldsForXls[this.$t('editedjson.assignedUserId')]='email',
						this.csvFieldsForXls[this.$t('editedjson.assignedUserName')]='fullname',


						this.listReportDataforxls = result.data.data;
					} else {
						if (result.data.status == true) {
							this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}


				}, error => {
					console.error(error)
				})

		},

		resetAllCompletedForm() {
			this.show = false;
			this.download = true;
			this.listCompletedData = {
				totalquantity: 0,
				result: [],
			};
			this.zoneBatchPending = '';
			this.fromDateCompleted = '';
			this.toDateCompleted = '';
			this.pickeridCompleted = '';
			this.totalPage = 0;
			this.totalRows = 0;
		},

		/*  End For the Fourth Tab */


		resetAllAllocatedForm() {
			this.show = false;
			this.download = true;
			this.listAllocatedInpickingData = {
				totalquantity: 0,
				result: [],
			};
			this.zoneBatchPending = '';
			this.fromDateAllocated = '';
			this.toDateAllocated = '';
			this.allocatedbatchids = [];
			this.selectAllAllocated = false;
			this.pickeridAllocated = '';
			this.totalPage = 0;
			this.totalRows = 0;
		},


		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.perPage
		// 	this.getOrderListReport()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getPendinAllocationBatch()
		},
		onPageChange1(page) {
			this.currentPage = page;
			this.getAllocatedPendingBatches()
		},
		onPageChange2(page) {
			this.currentPage = page;
			this.getCompletedBatches()
		},

		resetBatchPending() {
			this.show = false;
			this.download = true;
			this.listpendingForBatchData = {
				totalquantity: 0,
				result: [],
			};
			this.zoneBatchPending = '';
			this.fromDateBatchPending = '';
			this.toDateBatchPending = '';
			this.orderid = '';
			document.getElementById("orderid").value = '';
			this.searchchannel = '';
		},


		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {}).catch(() => {});
		},
	} // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/zonepickingreport/zonepickingreport.component.js